/**
 * VoicesPanel - Shows 2-4 character advisors and their advice
 */
import React from 'react';
import { motion } from 'framer-motion';

const VoicesPanel = ({ voices }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {voices.map((voice, index) => (
        <motion.div
          key={voice.character_id}
          className="border border-hairline bg-bone-raised rounded-lg p-6"
          initial={{ opacity: 0, x: index % 2 === 0 ? -12 : 12 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
        >
          <div className="flex items-start gap-4">
            <div className="text-3xl" aria-hidden="true">
              {voice.character_icon}
            </div>
            <div className="flex-1">
              <div className="font-display text-h3 text-primary mb-2">{voice.character_name}</div>
              <div className="text-body text-secondary leading-relaxed">{voice.advice}</div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default VoicesPanel;
